export default {
  en: {
    messages: {
      download_will_begin: 'Your download will begin shortly.',
      download_not_available: 'The selected file is not available for download.',
    },
    global: {
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        save: 'Save',
        send: 'Send',
        update: 'Update',
        verify: 'Verify',
      },
      general: {
        logout: 'Logout',
        required: 'This field is required',
      },
      inputs: {
        choose_file: 'Choose File...',
        choose_files: 'Choose Files...',
      },
    },
  },
  es: {
    global: {
      inputs: {
        choose_file: 'Elegir Archivo...',
        choose_files: 'Elegir Archivos...',
      },
      general: {
        logout: 'Cerrar Sesión',
        required: 'Este campo es obligatorio',
      },
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        save: 'Guardar',
        send: 'Enviar',
        update: 'Actualizar',
        verify: 'Verificar',
      },
    },
  },
}
